//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "International_Index_of_Erectile_Function",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "1", name: "很低" },
        { value: "2", name: "低" },
        { value: "3", name: "中等" },
        { value: "4", name: "高" },
        { value: "5", name: "很高" },
      ],
      dataList1: [
        { value: "0", name: "无性交活动" },
        { value: "1", name: "几乎没有或完全没有" },
        { value: "2", name: "少数几次（远低于一半次数" },
        { value: "3", name: "有时（约一半次数）" },
        { value: "4", name: "大多数时候（远超过一半次数" },
        { value: "5", name: "几乎总是或总是" },
      ],
      dataList2: [
        { value: "0", name: "没有尝试性交" },
        { value: "1", name: "几乎没有或完全没有" },
        { value: "2", name: "少数几次（远低于一半次数）" },
        { value: "3", name: "有时（约一半次数）" },
        { value: "4", name: "大多数时候（远超过一半次数" },
        { value: "5", name: "几乎总是或总是" },
      ],
      dataList3: [
        { value: "0", name: "没有尝试性交" },
        { value: "1", name: "困难极大" },
        { value: "2", name: "困难很大" },
        { value: "3", name: "困难" },
        { value: "4", name: "有点困难" },
        { value: "5", name: "不困难" },
      ],
      dataList4: [
        { value: "0", name: "没有尝试性交" },
        { value: "1", name: "几乎没有或完全没有" },
        { value: "2", name: "少数几次（远低于一半次数）" },
        { value: "3", name: "有时（约一半次数）" },
        { value: "4", name: "大多数时候（远超过一半次数）" },
        { value: "5", name: "几乎总是或总是" },
      ],
      dataList5: [
        { value: "0", name: "≤400" },
        { value: "1", name: "＞400" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/International_Index_of_Erectile_Function.vue